__turbopack_context__.v({
  "leftIcon": "rGD-sG_leftIcon",
  "linkButton": "rGD-sG_linkButton",
  "rightIcon": "rGD-sG_rightIcon",
});
